import React, { useState } from "react";
import Post from "./Post";
import { PostProperties } from "./AllPost";

interface PostGridProps {
  posts: PostProperties[];
}

const PostGrid: React.FC<PostGridProps> = ({ posts }) => {
  const [visiblePosts, setVisiblePosts] = useState<number>(5);

  const handleLoadMore = () => {
    setVisiblePosts((prevVisiblePosts) => prevVisiblePosts + 5);
  };

  return (
    <div className="container mx-auto">
      <div className="grid grid-cols-1 gap-4 mt-8">
        {posts.slice(0, visiblePosts).map((post) => (
          <Post
            key={post.id}
            title={post.title}
            content={post.content}
            image={post.image}
            category={post.category}
            buttonText={post.buttonText}
            buttonUrl={post.buttonUrl}
          />
        ))}
      </div>
      {visiblePosts < posts.length && (
        <div className="flex justify-end mb-8">
          <button
            onClick={handleLoadMore}
            className="bg-[#c1282dff] hover:bg-[#606060] text-white py-2 px-4"
            aria-label={`Load more posts. Showing ${visiblePosts} of ${posts.length}`}
          >
            Load More
          </button>
        </div>
      )}
    </div>
  );
};

export default PostGrid;
